import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdsArraySearchValueObject} from './FilterIdsArraySearchValueObject.js'

export class FilterBodyTypeIdsSearchValueObject extends ValueObject {
  #bodyTypeIds

  constructor({bodyTypeIds}) {
    super()
    this.#bodyTypeIds = bodyTypeIds
  }

  static create({bodyTypeIds}) {
    return new FilterBodyTypeIdsSearchValueObject({
      bodyTypeIds: FilterIdsArraySearchValueObject.createForNumbers({value: bodyTypeIds})
    })
  }

  static validate({bodyTypeIds}) {
    if (bodyTypeIds === null || bodyTypeIds === undefined) {
      throw new InvalidParamsSharedError('Body type ids is required')
    }
  }

  static createNonEmpty({bodyTypeIds}) {
    FilterBodyTypeIdsSearchValueObject.validate({bodyTypeIds})
    return new FilterBodyTypeIdsSearchValueObject({
      bodyTypeIds: FilterIdsArraySearchValueObject.createForNumbers({value: bodyTypeIds})
    })
  }

  static createWithDefaultValue({config, bodyTypeIds}) {
    const {DEFAULT_BODY_TYPE_IDS_SEARCH} = config.get('searchFilters')

    return new FilterBodyTypeIdsSearchValueObject({
      bodyTypeIds: FilterIdsArraySearchValueObject.createForNumbers({
        value: bodyTypeIds ?? DEFAULT_BODY_TYPE_IDS_SEARCH
      })
    })
  }

  static createQueryParams({config, bodyTypeIds}) {
    const {DEFAULT_BODY_TYPE_IDS_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterBodyTypeIdsSearchValueObject({
      bodyTypeIds: QueryParamSharedValueObject.createForPipeArray({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.BODY_TYPE],
        value: bodyTypeIds ?? DEFAULT_BODY_TYPE_IDS_SEARCH
      })
    })
  }

  get isEmpty() {
    return this.#bodyTypeIds.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#bodyTypeIds.queryParam})
    }
  }

  get value() {
    return this.#bodyTypeIds.value
  }

  toJSON() {
    return {
      bodyTypeIds: this.#bodyTypeIds.toJSON()
    }
  }
}
